"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _md = require("react-icons/md");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Pagination(_ref) {
  let {
    totalLength,
    currentPage,
    pageSize,
    handlePageChange,
    paginationStyle,
    classes,
    isLoading
  } = _ref;
  const [totalPage, setTotalPage] = (0, _react.useState)(Math.ceil(totalLength / pageSize) || 1);
  const [isPrevious, setIsPrevious] = (0, _react.useState)(false);
  const [isNext, setIsNext] = (0, _react.useState)(false);
  const [isFirst, setIsFirst] = (0, _react.useState)(false);
  const [isLast, setIsLast] = (0, _react.useState)(false);
  const currentPageStatus = () => {
    if (!currentPage || currentPage == 1 && totalPage == currentPage) {
      setIsPrevious(false);
      setIsFirst(false);
      setIsNext(false);
      setIsLast(false);
    } else if (currentPage == 1 && totalPage > 1) {
      setIsPrevious(false);
      setIsFirst(false);
      setIsNext(true);
      setIsLast(true);
    } else if (currentPage > 1 && currentPage == totalPage) {
      setIsPrevious(true);
      setIsFirst(true);
      setIsNext(false);
      setIsLast(false);
    } else {
      setIsPrevious(true);
      setIsFirst(true);
      setIsNext(true);
      setIsLast(true);
    }
  };
  const setPagination = () => {
    const totPage = Math.ceil(totalLength / pageSize) || 1;
    setTotalPage(totPage);
    currentPageStatus();
  };
  (0, _react.useEffect)(() => {
    setPagination();
  }, [totalLength, pageSize, currentPage, isLoading]);
  (0, _react.useEffect)(() => {
    currentPageStatus();
  }, [totalPage]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: paginationStyle
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.padmar5
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: "Page ".concat(currentPage || 1, " of ").concat(totalPage),
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      fontFamily: 'Poppins'
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.padmar5,
    "data-testid": "table-page-item",
    onClick: currentPage > 1 ? () => handlePageChange(1) : null
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: /*#__PURE__*/_react.default.createElement(_md.MdOutlineFirstPage, {
      className: "".concat(isFirst ? "active-click" : ""),
      style: {
        fontSize: 25,
        cursor: "".concat(isFirst ? "pointer" : ''),
        color: "".concat(isFirst ? "#0D0E0F" : "#9A9A9A")
      }
    }),
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      fontFamily: 'Poppins'
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.padmar5,
    "data-testid": "table-page-item",
    onClick: () => currentPage > 1 ? handlePageChange(currentPage - 1) : null
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: /*#__PURE__*/_react.default.createElement(_md.MdOutlineNavigateBefore, {
      className: "".concat(isPrevious ? "active-click" : ""),
      style: {
        fontSize: 25,
        cursor: "".concat(isPrevious ? "pointer" : ""),
        color: "".concat(isPrevious ? "#0D0E0F" : "#9A9A9A")
      }
    }),
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      fontFamily: 'Poppins'
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.padmar5,
    "data-testid": "table-page-item",
    onClick: () => currentPage < totalPage ? handlePageChange(currentPage + 1) : null
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: /*#__PURE__*/_react.default.createElement(_md.MdOutlineNavigateNext, {
      className: "".concat(isNext ? "active-click" : ""),
      style: {
        fontSize: 25,
        cursor: "".concat(isNext ? "pointer" : ""),
        color: "".concat(isNext ? "#0D0E0F" : "#9A9A9A")
      }
    }),
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      fontFamily: 'Poppins'
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.padmar5,
    "data-testid": "table-page-item",
    onClick: currentPage < totalPage ? () => handlePageChange(totalPage) : null
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: /*#__PURE__*/_react.default.createElement(_md.MdOutlineLastPage, {
      className: "".concat(isLast ? "active-click" : ""),
      style: {
        fontSize: 25,
        cursor: "".concat(isLast ? "pointer" : ""),
        color: "".concat(isLast ? "#0D0E0F" : "#9A9A9A")
      }
    }),
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      fontFamily: 'Poppins'
    }
  })));
}
var _default = exports.default = Pagination;